import { render, staticRenderFns } from "./CaseTertiaryMetrics.vue?vue&type=template&id=0ce99a7a&scoped=true"
import script from "./CaseTertiaryMetrics.vue?vue&type=script&lang=ts"
export * from "./CaseTertiaryMetrics.vue?vue&type=script&lang=ts"
import style0 from "./CaseTertiaryMetrics.vue?vue&type=style&index=0&id=0ce99a7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce99a7a",
  null
  
)

export default component.exports